import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';
import { User, LoginData, TwoFactorCode, PasswordSetup, ForgotEmail, resetPasswordData } from 'src/app/modals/Authentication/auth.models';
import { from, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ResponseService } from 'src/app/modals/response/response-service.model';
import { LocalStorageService } from './local-storage.service';


@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;
    loginData : LoginData;

    constructor(
        public httpService: HttpClient,
        public localStorageService: LocalStorageService,
    ) {}

    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }

    logins(email: string, password: string) {

        this.loginData = {
            "email": email,
            "password": password
        }       

        console.log("sending request auth.service");
        return this.httpService.post<ResponseService>("login", this.loginData);
    }

    applyLogin(urlData: string) {
        return this.httpService.post<ResponseService>(urlData, {});
    }

    enable2Fa(otp: TwoFactorCode){
        return this.httpService.post<ResponseService>("enable-two-factor", otp);
    }

    logout() {
        // logout the user
        return this.httpService.post<ResponseService>("logout", null);
    }

    passwordSetup(password: PasswordSetup){
        return this.httpService.post<ResponseService>("password-setup", password);
    }

    forgotPassword(email: ForgotEmail) {
        return this.httpService.post<ResponseService>("forgot-password", email);
    }

    resetPassword(data: resetPasswordData) {
        return this.httpService.post<ResponseService>("reset-password", data);
    }

    fetch2FAStatus(){
        const status:string = (this.localStorageService.getItem('2fa_status') ?? "0");
        return status;
    }

    resetAll(){
        this.localStorageService.clear();
        window.sessionStorage.clear();
    }

    setToken() {
        const currentDate = new Date();
        
        // Set the expiration date to 59 days from now
        const expirationDate = new Date();
        expirationDate.setDate(currentDate.getDate() + 59);

        this.localStorageService.setItem('tokenExpiration', expirationDate.toISOString()); // Save as ISO string for easy comparison
    }

    setUserObject(userDetails){
        this.localStorageService.setItem('currentUser', userDetails);
    }

    isTokenExpired() {
        
        const tokenExpiration:string = this.localStorageService.getItem('tokenExpiration');
        const userDataExist = this.localStorageService.getItem('currentUser');

        if (!tokenExpiration) {
            return true; // If no expiration date, assume token is expired
        }

        const expirationDate = new Date(tokenExpiration);
        const currentDate = new Date();

        // Check if the current date is after the expiration date
        return (currentDate > expirationDate || !userDataExist);
    }

    pushUserData(user) {
    
        const userDetails: User = {
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            qrcode: user.qrcode,
            avatar: user.avatar,
            two_factor_backup_codes: user.two_factor_backup_codes
        };
    
        this.setUserObject(user);
        return userDetails;
        
    }
}